<!--
 * @Author: your name
 * @Date: 2020-11-04 14:52:22
 * @LastEditTime: 2021-01-29 15:22:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\pages\home.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-04 14:52:22
 * @LastEditTime: 2020-11-05 09:32:16
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\pages\home.vue
-->
<template>
   <div class="home" :style="{height:screenHeight + 'px'}">
      <Head />
      <router-view></router-view>
      <Footer />
  </div>
</template>

<script>
import Head from './../components/public/head'
import Footer from './../components/public/footer'
export default {
  components: {
    Head,
    Footer,
  },
  data(){
    return {
       screenHeight: window.innerHeight,
    }
  }
}
</script>

<style lang="scss">
.home {
  height: 100%;
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  }
 

</style>


// WEBPACK FOOTER //
// src/pages/home.vue